import { Box } from '@mui/material'
import React, { ReactNode } from 'react'
import styles from './detailsItemCard.module.css'
import { FINAL_TECHNICAL_OUTCOME } from '../../../../../utils/constants/applicationDetailsBifurcation'
import { ShowcaseTime } from '../timeShowcase/showcaseTime'

export const DetailsItemCard = ({ 
  itemKey,
  label,
  value,
  timeStamp
}: {
  itemKey: string;
  label: string;
  value: ReactNode;
  timeStamp?: string;
}) => {
  return (
    <Box className={styles.detailItem}>
      <Box className={`${styles.headerTxt} ${itemKey === FINAL_TECHNICAL_OUTCOME ? styles.finalTechnicalOutcomeHeader : ""}`}>{label}</Box>
      <Box className={styles.bodyTxt}>{value}</Box>
      {timeStamp && <ShowcaseTime timeStamp={timeStamp} />}
    </Box>
  )
}
